import { ROUTES } from 'utils/constants/routes';

/**
 * Capture screens that exist in both flows. A v2 user who lands on one of the originals — from a
 * stale link, the browser history or a typed URL — is sent to its v2 counterpart. Only these are
 * mapped: the error and timeout screens are shared, and redirecting them would break v2's own error
 * handling. Any other old path falls through to the v2 entry (`features/govtId/routes.jsx`).
 */
export const CAPTURE_ROUTE_EQUIVALENTS = {
    [ROUTES.GOVT_ID_VERIFICATION]: ROUTES.GOVT_ID_V2,
    [ROUTES.MOBILE_CAPTURE]: ROUTES.GOVT_ID_V2_CAPTURE_CAMERA,
    [ROUTES.GOVT_ID_PHOTO_CONFIRM]: ROUTES.GOVT_ID_V2_PHOTO_CONFIRM,
    [ROUTES.CAPTURE_SELFIE]: ROUTES.GOVT_ID_V2_CAPTURE_SELFIE,
};

export const getCaptureRouteEquivalent = (pathname) =>
    CAPTURE_ROUTE_EQUIVALENTS[pathname?.replace(/\/$/, '')] ?? null;
